import { cloudinaryVideo } from '../config/cloudinaryVideos';
import { isVideoUrl } from '../config/cloudinary';

/** Blog listing hero — Cloudinary CDN (1920px cap). */
export const DEFAULT_BLOG_HERO_VIDEO = cloudinaryVideo('8084751-uhd_3840_2160_25fps', 'hero');

export let BLOG_HERO_VIDEO = DEFAULT_BLOG_HERO_VIDEO;

/**
 * Pick the first usable MP4/Cloudinary video URL from candidates.
 */
export function resolveBlogHeroVideoUrl(...candidates) {
  for (const raw of candidates) {
    if (typeof raw === 'string' && isVideoUrl(raw)) return raw.trim();
  }
  return DEFAULT_BLOG_HERO_VIDEO;
}

export function hydrateBlogHeroVideo(url) {
  BLOG_HERO_VIDEO = resolveBlogHeroVideoUrl(url, BLOG_HERO_VIDEO);
}
